import { render, staticRenderFns } from "./NoContactabilidadPage.vue?vue&type=template&id=086a3445&scoped=true"
import script from "./NoContactabilidadPage.vue?vue&type=script&lang=js"
export * from "./NoContactabilidadPage.vue?vue&type=script&lang=js"
import style0 from "./NoContactabilidadPage.vue?vue&type=style&index=0&id=086a3445&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a3445",
  null
  
)

export default component.exports